export default __webpack_public_path__ + "static/licence-WA-75a8022195d3fbff86bf5aa1bce67994.svg";